import React from 'react';
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
  Cell,
} from 'recharts';
import { useProduct } from '../../context/ProductContext';
type BotViewTime = {
  botName: string;
  averageViewTimeMinutes: number;
};

const PURPLE_SHADES = [
  '#8b2cd7',
  '#9c43dc',
  '#ad5ae1',
  '#be71e6',
  '#cf88eb',
  '#e0a0f0',
  '#f1b7f5',
];

const BLUE_SHADES = [
  '#2563eb', // base blue
  '#3b82f6', // lighter, more vibrant
  '#60a5fa',
  '#93c5fd',
  '#bfdbfe',
  '#dbeafe',
  '#eff6ff',
];

const GREEN_SHADES = [
  '#10B981', // base green (emerald 500)
  '#34D399', // lighter, more vibrant (emerald 400)
  '#6EE7B7', // softer light green (emerald 300)
  '#A7F3D0', // pastel green (emerald 200)
  '#D1FAE5', // very light green (emerald 100)
  '#ECFDF5', // pale green background (emerald 50)
  '#F9FFFB', // almost white with green hint (custom ultra-light)
];

const BotViewTimeChart: React.FC<{ data: BotViewTime[] }> = ({ data }) => {
  const { product } = useProduct();
  const palette =
  product === "site-assistant"
    ? BLUE_SHADES
    : product === "bot-canvas"
    ? GREEN_SHADES 
    : PURPLE_SHADES;
  return (
    <div style={{ width: '100%', height: '100%' }}>
      <ResponsiveContainer width="100%" height="100%">
        <BarChart
          data={data}
          layout="vertical"
          margin={{ top: 10, right: 10, left: -40, bottom: 10 }}
        >
          <XAxis
            type="number"
            label={{
              value: 'Minutes Viewed',
              position: 'insideBottom',
              offset: -5,
              style: { fontFamily: 'Montserrat', fontSize: 12 },
            }}
            stroke="#333"
            tick={{ fontFamily: 'Montserrat', fontSize: 12 }}
          />
          <YAxis
            type="category"
            dataKey="botName"
            stroke="#333"
            tick={false} // hides the Y-axis labels
            axisLine={false} // optional: hide axis line
          />
          <Tooltip
            formatter={(value: number, _, props: any) => [
              `${value} min`,
              props.payload.botName,
            ]}
            contentStyle={{
              fontFamily: 'Montserrat',
              fontSize: 12,
              borderRadius: '8px',
            }}
          />
          <Bar dataKey="averageViewTimeMinutes" radius={[0, 6, 6, 0]}>
            {data.map((_, index) => (
              <Cell
                key={`cell-${index}`}
                fill={palette[index % palette.length]}
              />
            ))}
          </Bar>
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
};

export default BotViewTimeChart;
